import { z } from 'zod';
import { postData } from "../api/fetch";

export async function submitPasswordResetForm(prevState, formData) {

    const LoginFormSchema = z.object({
        email: z
            .email({ message: "Ongeldig e-mailadres." })
            .min(1, { message: "Vul een e-mailadres in." })
            .max(100, { message: "E-mailadres is te lang." }),
    });

    const rawData = {
        email: formData.get("email"),
    };

    const validatedFields = LoginFormSchema.safeParse(rawData);

    if (!validatedFields.success) {
        return {
            ok: false,
            errors: validatedFields.error.flatten().fieldErrors,
            ...rawData,
        }
    }

    try {
        const data = await postData('website/forgot-password', Object.fromEntries(formData));

        if (!data || data.error) return {
            ok: false,
            message: "Er ging iets mis bij het aanvragen van de wachtwoord reset link."
        }

        return {
            ok: true
        }
    } catch (err) {
        return {
            ok: false,
            message: "Er ging iets mis bij het aanvragen van de wachtwoord reset link."
        }
    }
}